"use client"

import { useTheme, useMediaQuery } from "@mui/material"
import { useSelector } from "react-redux"
import { makeStyles } from "tss-react/mui"
import { useState, useEffect } from "react"
import Logo from "../resources/images/logo.svg?react"

const useStyles = makeStyles()((theme) => ({
  image: {
    alignSelf: "center",
    maxWidth: "300px",
    maxHeight: "150px",
    width: "auto",
    height: "auto",
    margin: theme.spacing(2),
  },
}))

// Normalize path to ensure absolute URL (prepend '/' if needed)
const normalizePath = (path) => {
  if (!path) return ""
  if (path.startsWith("http") || path.startsWith("/")) {
    return path
  }
  return `/${path}`
}

const LogoImage = ({ color, alt, onLoad, style }) => {
  const theme = useTheme()
  const { classes } = useStyles()
  const expanded = !useMediaQuery(theme.breakpoints.down("lg"))

  // Funcionalidade de revenda adicionada
  const revenda = useSelector((state) => state.session.revenda)
  const logo = useSelector((state) => state.session.server.attributes?.logo)
  const logoInverted = useSelector((state) => state.session.server.attributes?.logoInverted)

  const [revendaLogoUrl, setRevendaLogoUrl] = useState(null)

  // Efeito para carregar logo da revenda
  useEffect(() => {
    if (revenda?.code) {
      setRevendaLogoUrl(`./themes/${revenda.code}/logo.png`)
    }
  }, [revenda])

  const imgProps = { className: classes.image, alt: alt || "Logomarca", onLoad, style }

 
  let src = null

  if (revendaLogoUrl && revenda) {
   
    src = revendaLogoUrl
  } else if (logo) {

    src = normalizePath(expanded && logoInverted ? logoInverted : logo)
  }

  if (src) {
    return <img {...imgProps} src={src || "/placeholder.svg"} alt={alt || revenda?.title || "Logo"} />
  }

  return <Logo {...imgProps} style={{ ...style, color }} />
}

export default LogoImage